import { bool, func, string } from "prop-types";
import React from "react";



import styled from "styled-components/macro";



import { motion } from "motion/react";



import FnrIcon from "UI/FnrIcon";


function ExpandableStat({
  icon,
  expandableText,
  staticText,
  selected,
  setSelectedStat,
  stat,
}) {
  return (
    <Wrapper
      onMouseEnter={() => setSelectedStat(stat)}
      onClick={(e) => {
        e.stopPropagation();
      }}
      data-cy="ExpandableStat"
    >
      <StaticContent>
        <FnrIcon icon={icon} />
        <span>{staticText}</span>
      </StaticContent>

      <ExpandableContent
        initial={{ opacity: 0, width: 0 }}
        animate={{
          opacity: selected ? 1 : 0,
          width: selected ? "auto" : 0,
        }}
        transition={{ duration: 0.2 }}
      >
        <ExpandableText>{expandableText}</ExpandableText>
      </ExpandableContent>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-block-start: 0.75rem;
  margin-inline: 0.75rem;
  cursor: pointer;

  span {
    font-size: 0.875rem;
  }
`;

const StaticContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.24rem;
`;

const ExpandableContent = styled(motion.div)`
  overflow: hidden;
`;

const ExpandableText = styled.span`
  white-space: nowrap;

  &:before {
    content: " ";
    margin-left: 0.25rem;
  }
`;

export default ExpandableStat;

ExpandableStat.propTypes = {
  icon: string.isRequired,
  expandableText: string.isRequired,
  staticText: string.isRequired,
  selected: bool.isRequired,
  setSelectedStat: func.isRequired,
  stat: string.isRequired,
};